
import controller from '@/components/shifts/ShiftOfferCard/controller';

export default controller;
